import {
  Button,
  Card,
  CardContent,
  Grid,
  Heading,
  Stack,
  Text,
} from "@generalapplications/ui";

import { Reveal } from "@/app/common/components/composite/motion/Reveal";
import { formatText } from "@/app/common/functions/format/formatText";

export type ClosingBandProps = {
  headline: string;
  copy: readonly string[];
  cta: string;
  ctaHref: string;
};

/** The panel that ends a page: the question, a few lines, one way forward. */
export function ClosingBand({
  headline,
  copy,
  cta,
  ctaHref,
}: ClosingBandProps) {
  return (
    <Reveal>
      <Card variant="glass" radius="xxl" padding="xl">
        <CardContent>
          <Grid as="section" columns={{ base: 1, lg: 2 }} gap="xl">
            <Heading level={2} size="xxl">
              {formatText(headline)}
            </Heading>
            <Stack gap="lg" align="start">
              {copy.map((paragraph) => (
                <Text key={paragraph} variant="lead">
                  {formatText(paragraph)}
                </Text>
              ))}
              <Button href={ctaHref} size="xl">
                {cta}
              </Button>
            </Stack>
          </Grid>
        </CardContent>
      </Card>
    </Reveal>
  );
}
